import { Injectable } from '@angular/core';
export class DomHandler {
public static zindex: number = 1000;
private calculatedScrollbarWidth: number = null;
private browser: any;
/**
 * @param {?} element
 * @param {?} className
 * @return {?}
 */
public addClass(element: any, className: string): void {
        if (element.classList)
            element.classList.add(className);
        else
            element.className += ' ' + className;
    }
/**
 * @param {?} element
 * @param {?} className
 * @return {?}
 */
public addMultipleClasses(element: any, className: string): void {
        if (element.classList) {
            let /** @type {?} */ styles: string[] = className.split(' ');
            for (let /** @type {?} */ i = 0; i < styles.length; i++) {
                element.classList.add(styles[i]);
            }

        }
        else {
            let /** @type {?} */ styles: string[] = className.split(' ');
            for (let /** @type {?} */ i = 0; i < styles.length; i++) {
                element.className += ' ' + styles[i];
            }
        }
    }
/**
 * @param {?} element
 * @param {?} className
 * @return {?}
 */
public removeClass(element: any, className: string): void {
        if (element.classList)
            element.classList.remove(className);
        else
            element.className = element.className.replace(new RegExp('(^|\\b)' + className.split(' ').join('|') + '(\\b|$)', 'gi'), ' ');
    }
/**
 * @param {?} element
 * @param {?} className
 * @return {?}
 */
public hasClass(element: any, className: string): boolean {
        if (element.classList)
            return element.classList.contains(className);
        else
            return new RegExp('(^| )' + className + '( |$)', 'gi').test(element.className);
    }
/**
 * @param {?} element
 * @return {?}
 */
public siblings(element: any): any {
        return Array.prototype.filter.call(element.parentNode.children, function (child) {
            return child !== element;
        });
    }
/**
 * @param {?} element
 * @param {?} selector
 * @return {?}
 */
public find(element: any, selector: string): any[] {
        return element.querySelectorAll(selector);
    }
/**
 * @param {?} element
 * @param {?} selector
 * @return {?}
 */
public findSingle(element: any, selector: string): any {
        return element.querySelector(selector);
    }
/**
 * @param {?} element
 * @return {?}
 */
public index(element: any): number {
        let /** @type {?} */ children = element.parentNode.childNodes;
        let /** @type {?} */ num = 0;
        for (var /** @type {?} */ i = 0; i < children.length; i++) {
            if (children[i] == element) return num;
            if (children[i].nodeType == 1) num++;
        }
        return -1;
    }
/**
 * @param {?} element
 * @param {?} attributeName
 * @return {?}
 */
public indexWithinGroup(element: any, attributeName: string): number {
        let /** @type {?} */ children = element.parentNode.childNodes;
        let /** @type {?} */ num = 0;
        for (var /** @type {?} */ i = 0; i < children.length; i++) {
            if (children[i] == element) return num;
            if (children[i].attributes && children[i].attributes[attributeName] && children[i].nodeType == 1) num++;
        }
        return -1;
    }
/**
 * @param {?} element
 * @param {?} target
 * @return {?}
 */
public relativePosition(element: any, target: any): void {
        let /** @type {?} */ elementDimensions = element.offsetParent ? { width: element.offsetWidth, height: element.offsetHeight } : this.getHiddenElementDimensions(element);
        let /** @type {?} */ targetHeight = target.offsetHeight;
        let /** @type {?} */ targetWidth = target.offsetWidth;
        let /** @type {?} */ targetOffset = target.getBoundingClientRect();
        let /** @type {?} */ windowScrollTop = this.getWindowScrollTop();
        let /** @type {?} */ viewport = this.getViewport();
        let /** @type {?} */ top, /** @type {?} */ left;
        
        if ((targetOffset.top + targetHeight + elementDimensions.height) > viewport.height) {
            top = -1 * (elementDimensions.height);
            if(targetOffset.top + top < 0) {
                top = 0;
            }
        }
        else {
            top = targetHeight;
        }
            
            
        if ((targetOffset.left + elementDimensions.width) > viewport.width)
            left = targetWidth - elementDimensions.width;
        else
            left = 0;

        element.style.top = top + 'px';
        element.style.left = left + 'px';
    }
/**
 * @param {?} element
 * @param {?} target
 * @return {?}
 */
public absolutePosition(element: any, target: any): void {
        let /** @type {?} */ elementDimensions = element.offsetParent ? { width: element.offsetWidth, height: element.offsetHeight } : this.getHiddenElementDimensions(element);
        let /** @type {?} */ elementOuterHeight = elementDimensions.height;
        let /** @type {?} */ elementOuterWidth = elementDimensions.width;
        let /** @type {?} */ targetOuterHeight = target.offsetHeight;
        let /** @type {?} */ targetOuterWidth = target.offsetWidth;
        let /** @type {?} */ targetOffset = target.getBoundingClientRect();
        let /** @type {?} */ windowScrollTop = this.getWindowScrollTop();
        let /** @type {?} */ windowScrollLeft = this.getWindowScrollLeft();
        let /** @type {?} */ viewport = this.getViewport();
        let /** @type {?} */ top, /** @type {?} */ left;

        if (targetOffset.top + targetOuterHeight + elementOuterHeight > viewport.height) {
            top = targetOffset.top + windowScrollTop - elementOuterHeight;
            if(top < 0) {
                top = 0 + windowScrollTop;
            }
        } 
        else {
            top = targetOuterHeight + targetOffset.top + windowScrollTop;
        }

        if (targetOffset.left + targetOuterWidth + elementOuterWidth > viewport.width)
            left = targetOffset.left + windowScrollLeft + targetOuterWidth - elementOuterWidth;
        else
            left = targetOffset.left + windowScrollLeft;

        element.style.top = top + 'px';
        element.style.left = left + 'px';
    }
/**
 * @param {?} element
 * @return {?}
 */
public getHiddenElementOuterHeight(element: any): number {
        element.style.visibility = 'hidden';
        element.style.display = 'block';
        let /** @type {?} */ elementHeight = element.offsetHeight;
        element.style.display = 'none';
        element.style.visibility = 'visible';

        return elementHeight;
    }
/**
 * @param {?} element
 * @return {?}
 */
public getHiddenElementOuterWidth(element: any): number {
        element.style.visibility = 'hidden';
        element.style.display = 'block';
        let /** @type {?} */ elementWidth = element.offsetWidth;
        element.style.display = 'none';
        element.style.visibility = 'visible';

        return elementWidth;
    }
/**
 * @param {?} element
 * @return {?}
 */
public getHiddenElementDimensions(element: any): any {
        let /** @type {?} */ dimensions: any = {};
        element.style.visibility = 'hidden';
        element.style.display = 'block';
        dimensions.width = element.offsetWidth;
        dimensions.height = element.offsetHeight;
        element.style.display = 'none';
        element.style.visibility = 'visible';

        return dimensions;
    }
/**
 * @param {?} container
 * @param {?} item
 * @return {?}
 */
public scrollInView(container, item) {
        let /** @type {?} */ borderTopValue: string = getComputedStyle(container).getPropertyValue('borderTopWidth');
        let /** @type {?} */ borderTop: number = borderTopValue ? parseFloat(borderTopValue) : 0;
        let /** @type {?} */ paddingTopValue: string = getComputedStyle(container).getPropertyValue('paddingTop');
        let /** @type {?} */ paddingTop: number = paddingTopValue ? parseFloat(paddingTopValue) : 0;
        let /** @type {?} */ containerRect = container.getBoundingClientRect();
        let /** @type {?} */ itemRect = item.getBoundingClientRect();
        let /** @type {?} */ offset = (itemRect.top + document.body.scrollTop) - (containerRect.top + document.body.scrollTop) - borderTop - paddingTop;
        let /** @type {?} */ scroll = container.scrollTop;
        let /** @type {?} */ elementHeight = container.clientHeight;
        let /** @type {?} */ itemHeight = this.getOuterHeight(item);

        if (offset < 0) {
            container.scrollTop = scroll + offset;
        }
        else if ((offset + itemHeight) > elementHeight) {
            container.scrollTop = scroll + offset - elementHeight + itemHeight;
        }
    }
/**
 * @param {?} element
 * @param {?} duration
 * @return {?}
 */
public fadeIn(element, duration: number): void {
        element.style.opacity = 0;

        let /** @type {?} */ last = +new Date();
        let /** @type {?} */ opacity = 0;
        let /** @type {?} */ tick = function () {
            opacity = +element.style.opacity.replace(",", ".") + (new Date().getTime() - last) / duration;
            element.style.opacity = opacity;
            last = +new Date();

            if (+opacity < 1) {
                (window.requestAnimationFrame && requestAnimationFrame(tick)) || setTimeout(tick, 16);
            }
        };

        tick();
    }
/**
 * @param {?} element
 * @param {?} ms
 * @return {?}
 */
public fadeOut(element, ms) {
        var /** @type {?} */ opacity = 1, /** @type {?} */
            interval = 50, /** @type {?} */
            duration = ms, /** @type {?} */
            gap = interval / duration;

        let /** @type {?} */ fading = setInterval(() => {
            opacity = opacity - gap;

            if (opacity <= 0) {
                opacity = 0;
                clearInterval(fading);
            }
            
            element.style.opacity = opacity;
        }, interval);
    }
/**
 * @return {?}
 */
public getWindowScrollTop(): number {
        let /** @type {?} */ doc = document.documentElement;
        return (window.pageYOffset || doc.scrollTop) - (doc.clientTop || 0);
    }
/**
 * @return {?}
 */
public getWindowScrollLeft(): number {
        let /** @type {?} */ doc = document.documentElement;
        return (window.pageXOffset || doc.scrollLeft) - (doc.clientLeft || 0);
    }
/**
 * @param {?} element
 * @param {?} selector
 * @return {?}
 */
public matches(element, selector: string): boolean {
        var /** @type {?} */ p = Element.prototype;
        var /** @type {?} */ f = p['matches'] || p.webkitMatchesSelector || p['mozMatchesSelector'] || p.msMatchesSelector || function (s) {
            return [].indexOf.call(document.querySelectorAll(s), this) !== -1;
        };
        return f.call(element, selector);
    }
/**
 * @param {?} el
 * @param {?=} margin
 * @return {?}
 */
public getOuterWidth(el, margin?) {
        let /** @type {?} */ width = el.offsetWidth;

        if (margin) {
            let /** @type {?} */ style = getComputedStyle(el);
            width += parseFloat(style.marginLeft) + parseFloat(style.marginRight);
        }

        return width;
    }
/**
 * @param {?} el
 * @return {?}
 */
public getHorizontalPadding(el) {
        let /** @type {?} */ style = getComputedStyle(el);
        return parseFloat(style.paddingLeft) + parseFloat(style.paddingRight);
    }
/**
 * @param {?} el
 * @return {?}
 */
public getHorizontalMargin(el) {
        let /** @type {?} */ style = getComputedStyle(el);
        return parseFloat(style.marginLeft) + parseFloat(style.marginRight);
    }
/**
 * @param {?} el
 * @return {?}
 */
public innerWidth(el) {
        let /** @type {?} */ width = el.offsetWidth;
        let /** @type {?} */ style = getComputedStyle(el);

        width += parseFloat(style.paddingLeft) + parseFloat(style.paddingRight);
        return width;
    }
/**
 * @param {?} el
 * @return {?}
 */
public width(el) {
        let /** @type {?} */ width = el.offsetWidth;
        let /** @type {?} */ style = getComputedStyle(el);

        width -= parseFloat(style.paddingLeft) + parseFloat(style.paddingRight);
        return width;
    }
/**
 * @param {?} el
 * @return {?}
 */
public getInnerHeight(el) {
        let /** @type {?} */ height = el.offsetHeight;
        let /** @type {?} */ style = getComputedStyle(el);

        height += parseFloat(style.paddingTop) + parseFloat(style.paddingBottom);
        return height;
    }
/**
 * @param {?} el
 * @param {?=} margin
 * @return {?}
 */
public getOuterHeight(el, margin?) {
        let /** @type {?} */ height = el.offsetHeight;

        if (margin) {
            let /** @type {?} */ style = getComputedStyle(el);
            height += parseFloat(style.marginTop) + parseFloat(style.marginBottom);
        }

        return height;
    }
/**
 * @param {?} el
 * @return {?}
 */
public getHeight(el): number {
        let /** @type {?} */ height = el.offsetHeight;
        let /** @type {?} */ style = getComputedStyle(el);

        height -= parseFloat(style.paddingTop) + parseFloat(style.paddingBottom) + parseFloat(style.borderTopWidth) + parseFloat(style.borderBottomWidth);

        return height;
    }
/**
 * @param {?} el
 * @return {?}
 */
public getWidth(el): number {
        let /** @type {?} */ width = el.offsetWidth;
        let /** @type {?} */ style = getComputedStyle(el);

        width -= parseFloat(style.paddingLeft) + parseFloat(style.paddingRight) + parseFloat(style.borderLeftWidth) + parseFloat(style.borderRightWidth);

        return width;
    }
/**
 * @return {?}
 */
public getViewport(): any {
        let /** @type {?} */ win = window, /** @type {?} */
            d = document, /** @type {?} */
            e = d.documentElement, /** @type {?} */
            g = d.getElementsByTagName('body')[0], /** @type {?} */
            w = win.innerWidth || e.clientWidth || g.clientWidth, /** @type {?} */
            h = win.innerHeight || e.clientHeight || g.clientHeight;

        return { width: w, height: h };
    }
/**
 * @param {?} el
 * @return {?}
 */
public getOffset(el) {
        let /** @type {?} */ rect = el.getBoundingClientRect();
        
        return {
            top: rect.top + document.body.scrollTop,
            left: rect.left + document.body.scrollLeft
        };
    }
/**
 * @return {?}
 */
getUserAgent(): string {
        return navigator.userAgent;
    }
/**
 * @return {?}
 */
isIE() {
        var /** @type {?} */ ua = window.navigator.userAgent;

        var /** @type {?} */ msie = ua.indexOf('MSIE ');
        if (msie > 0) {
            // IE 10 or older => return version number
            return true;
        }

        var /** @type {?} */ trident = ua.indexOf('Trident/');
        if (trident > 0) {
            // IE 11 => return version number
            var /** @type {?} */ rv = ua.indexOf('rv:');
            return true;
        }

        var /** @type {?} */ edge = ua.indexOf('Edge/');
        if (edge > 0) {
           // Edge (IE 12+) => return version number
           return true;
        }

        // other browser
        return false;
    }
/**
 * @param {?} element
 * @param {?} target
 * @return {?}
 */
appendChild(element: any, target: any) {
        if(this.isElement(target))
            target.appendChild(element);
        else if(target.el && target.el.nativeElement)
            target.el.nativeElement.appendChild(element);
        else
            throw 'Cannot append ' + target + ' to ' + element;
    }
/**
 * @param {?} element
 * @param {?} target
 * @return {?}
 */
removeChild(element: any, target: any) {
        if(this.isElement(target))
            target.removeChild(element);
        else if(target.el && target.el.nativeElement)
            target.el.nativeElement.removeChild(element);
        else
            throw 'Cannot remove ' + element + ' from ' + target;
    }
/**
 * @param {?} obj
 * @return {?}
 */
isElement(obj: any) {
        return (typeof HTMLElement === "object" ? obj instanceof HTMLElement :
            obj && typeof obj === "object" && obj !== null && obj.nodeType === 1 && typeof obj.nodeName === "string"
        );
    }
/**
 * @return {?}
 */
calculateScrollbarWidth(): number {
        if(this.calculatedScrollbarWidth !== null)
            return this.calculatedScrollbarWidth;
        
        let /** @type {?} */ scrollDiv = document.createElement("div");
        scrollDiv.className = "ui-scrollbar-measure";
        document.body.appendChild(scrollDiv);

        let /** @type {?} */ scrollbarWidth = scrollDiv.offsetWidth - scrollDiv.clientWidth;
        document.body.removeChild(scrollDiv);

        this.calculatedScrollbarWidth = scrollbarWidth;
        
        return scrollbarWidth;
    }
/**
 * @param {?} element
 * @param {?} methodName
 * @param {?=} args
 * @return {?}
 */
invokeElementMethod(element: any, methodName: string, args?: any[]): void {
        ( /** @type {?} */((element as any)))[methodName].apply(element, args);
    }
/**
 * @return {?}
 */
clearSelection(): void {
        if(window.getSelection) {
            if(window.getSelection().empty) {
                window.getSelection().empty();
            } else if(window.getSelection().removeAllRanges && window.getSelection().rangeCount > 0 && window.getSelection().getRangeAt(0).getClientRects().length > 0) {
                window.getSelection().removeAllRanges();
            }
        }
        else if(document['selection'] && document['selection'].empty) {
            try {
                document['selection'].empty();
            } catch( /** @type {?} */error) {
                //ignore IE bug
            }
        }
    }
/**
 * @return {?}
 */
getBrowser() {
        if(!this.browser) {
            let /** @type {?} */ matched = this.resolveUserAgent();
            this.browser = {};

            if (matched.browser) {
                this.browser[matched.browser] = true;
                this.browser['version'] = matched.version;
            }

            if (this.browser['chrome']) {
                this.browser['webkit'] = true;
            } else if (this.browser['webkit']) {
                this.browser['safari'] = true;
            }
        }

        return this.browser;
    }
/**
 * @return {?}
 */
resolveUserAgent() {
        let /** @type {?} */ ua = navigator.userAgent.toLowerCase();
        let /** @type {?} */ match = /(chrome)[ \/]([\w.]+)/.exec(ua) ||
            /(webkit)[ \/]([\w.]+)/.exec(ua) ||
            /(opera)(?:.*version|)[ \/]([\w.]+)/.exec(ua) ||
            /(msie) ([\w.]+)/.exec(ua) ||
            ua.indexOf("compatible") < 0 && /(mozilla)(?:.*? rv:([\w.]+)|)/.exec(ua) ||
            [];

        return {
            browser: match[1] || "",
            version: match[2] || "0"
        };
    }
static decorators: DecoratorInvocation[] = [
{ type: Injectable },
];
/**
 * @nocollapse
 */
static ctorParameters: () => ({type: any, decorators?: DecoratorInvocation[]}|null)[] = () => [
];
}

function DomHandler_tsickle_Closure_declarations() {
/** @type {?} */
DomHandler.zindex;
/** @type {?} */
DomHandler.decorators;
/**
 * @nocollapse
 * @type {?}
 */
DomHandler.ctorParameters;
/** @type {?} */
DomHandler.prototype.calculatedScrollbarWidth;
/** @type {?} */
DomHandler.prototype.browser;
}


interface DecoratorInvocation {
  type: Function;
  args?: any[];
}
